exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-htmljs-renderer-wrap[data-v-095187dc],.fts-htmljs-renderer[data-v-095187dc]{display:block;width:100%}", ""]);

// exports
